import React, { Fragment, SVGProps, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toggleBurgerMenu } from "store/application/application-action";
import BurgerMenuIcons from "./BurgerMenuIcons";
import { routes } from "routes";
import DiscordIconOutline from "components/icons/DiscordIconOutline.svg?react";
import RedditIconOutline from "components/icons/RedditIconOutline.svg?react";
import TwitterIconOutline from "components/icons/TwitterIconOutline.svg?react";
import InstagramIconOutline from "components/icons/InstagramIconOutline.svg?react";
import RightArrow from "components/icons/right_arrow.svg?react";
import FullRedgifsLogo from "components/icons/fullRedgifsLogo.svg?react";
import { links } from "components/ads/config/burgerMenu";
import useWindowDimensions from "hooks/useWindowDimension";
import { className } from "utils/strings";

import classes from "./BurgerMenu.module.scss";
import { CloseButton } from "../buttons/CloseButton";

const menuItems = [
  {
    text: "Cams",
    Icon: BurgerMenuIcons.RGCams,
    onClick: (isDesktop: boolean) => {
      window.location.href = isDesktop ? links.RGCamsDesktop : links.RGCams;
    },
  },
  {
    text: "Creator Blog",
    Icon: BurgerMenuIcons.HelpCenterIcon,
    url: "https://redgifs-creators.com/",
  },
  {
    text: "Submit Tags",
    Icon: BurgerMenuIcons.SubmitTagsIcon,
    onClick: () => {
      window.location.href = "https://bbciybcronr.typeform.com/to/ixYPtOb5?typeform-source=www.redgifs.com";
    },
  },
  {
    text: "Guidelines",
    Icon: BurgerMenuIcons.GuidelinesIcon,
    url: routes.guidelines(),
  },
  {
    text: "FAQ",
    Icon: BurgerMenuIcons.FAQIcon,
    url: routes.faq(),
  },
  {
    text: "Terms",
    Icon: BurgerMenuIcons.TermsIcon,
    url: routes.terms(),
  },
  {
    text: "Privacy Policy",
    Icon: BurgerMenuIcons.PrivacyIcon,
    url: routes.privacyPolicy(),
  },
  {
    text: "DMCA",
    Icon: BurgerMenuIcons.DMCAIcon,
    url: routes.dmca(),
  },
  {
    text: "2257 Statement",
    Icon: BurgerMenuIcons.StatementIcon,
    url: routes.statement2257(),
  }
] as IMenuItem[];

interface IMenuItem {
  text: string;
  Icon: React.FC<SVGProps<SVGSVGElement>>;
  url?: string;
  onClick?: (isDesktop: boolean) => void;
  isDesktopHidden?: boolean;
}

const BurgerMenu = () => {
  const url = window.location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isDesktop = useWindowDimensions();

  const handleClose = useCallback(() => {
    dispatch(toggleBurgerMenu());
  }, [dispatch]);

  const handleMenuItemClick = useCallback((item: IMenuItem) => () => {
    if (item.onClick) {
      item.onClick(isDesktop);
    }

    if (item.url && item.url.length > 1) {
      if (item.url.indexOf("https://") === 0) {
        window.open(item.url, "_blank");
      } else {
        navigate(item.url);
      }
    }

    handleClose();
  }, [handleClose, isDesktop, navigate]);

  return (
    <Fragment>
      <div className={classes.Container}>
        <div className={classes.LogoContainer}>
          <FullRedgifsLogo />
        </div>

        <div className={classes.CloseContainer}>
          <CloseButton onClick={handleClose}/>
        </div>

        <div className={classes.Items}>
          {
            menuItems.map((item, index) => {
              const { Icon } = item;
              return ((isDesktop && !item.isDesktopHidden) || !isDesktop ? (
                <div
                  key={index}
                  className={className({
                    [classes.Item]: true,
                    [classes.Item_IsCurrent]: url === item.url,
                  })}
                  onClick={handleMenuItemClick(item)}
                >
                  <RightArrow className={className({
                    [classes.ItemArrow]: true,
                    [classes.ItemArrow_IsCurrent]: url === item.url,
                  })} />
                  <Icon className={classes.ItemIcon} />
                  <span className={classes.ItemCaption}>{item.text}</span>
                </div>
              ) : null);
            })
          }
        </div>

        <div className={classes.SocialLinksContainer}>
          <div className={classes.SocialLinksCaption}>
            Social:
          </div>
          <div className={classes.SocialLinks}>
            <a href="https://discord.gg/w8fTWPn4Eb" target="_blank" rel="noreferrer" aria-label="Link to discord account">
              <DiscordIconOutline />
            </a>
            <a href="http://bit.ly/405rRS7" target="_blank" rel="noreferrer" aria-label="Link to reddit account">
              <RedditIconOutline />
            </a>
            <a href="https://bit.ly/405Qdey" target="_blank" rel="noreferrer" aria-label="Link to twitter account">
              <TwitterIconOutline />
            </a>
            <a href="https://bit.ly/3naK6an" target="_blank" rel="noreferrer" aria-label="Link to instagram account">
              <InstagramIconOutline />
            </a>
          </div>
        </div>

      </div >
      <div className={classes.Backdrop} onClick={handleClose}></div>
    </Fragment>
  );
};

export default BurgerMenu;
